import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';
import Axios from 'axios';
import rn from 'random-number';

const options = {
  min:  0 , max:  100, integer: true
}

export const BasicShowCase = ({ htmlURL, id, style, classNames }) => {
  const [availableHTML, isTheHTMLAvailable] = useState(false);

  useEffect(() => {
    Axios.get(htmlURL, {
      timeout: 30000,
      headers: {
        Accept: 'text/html'
      }
    }).then(() => isTheHTMLAvailable(true));
  }, []);
  return (
      availableHTML && (
        <div className={classNames} style={style}>
            <Iframe
            url={htmlURL}
            id={id}
            width="100%"
            height="0px"
            scrolling="no"
            />
        </div>
      )
  );
};

BasicShowCase.propTypes = {
  htmlURL: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  classNames: PropTypes.string
};

BasicShowCase.defaultProps = {
  id: rn(options),
  style: null,
  classNames: ''
};
